import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";
import { Dayjs } from "dayjs";

const environment = getEnvironment();

export enum NotificationType {
    Subscription = "subscription",
    Booking = "booking",
    Chat = "chat",
    User = "user",
    ConfirmationReview = "confirmation_review",
}

interface NotificationsListRaw {
    notifications: Notification[];
    total: number;
    start: number;
    count: number;
}

export default class Notification {
    key: string;
    type: NotificationType;
    object: string;
    message: string;
    created: Dayjs;
    viewed?: Dayjs;

    constructor(
        key: string,
        type: NotificationType,
        object: string,
        message: string,
        created: Dayjs,
        viewed?: Dayjs
    ) {
        this.key = key;
        this.type = type;
        this.object = object;
        this.message = message;
        this.created = created;
        this.viewed = viewed;
    }

    public static readonly list = async (
        uuid: string,
        brand: string,
        start: number = 0,
        count: number = 10,
        unread?: boolean
    ) =>
        (await axios
            .get(environment.api_url + "/" + brand + "/notifications/list", {
                headers: {
                    "User-Token": uuid,
                },
                params: {
                    start,
                    count,
                    unread: unread ? "true" : undefined,
                },
            })
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as NotificationsListRaw | undefined;

    public static readonly count = async (uuid: string, brand: string) =>
        (
            await axios
                .get(
                    environment.api_url + "/" + brand + "/notifications/count",
                    {
                        headers: {
                            "User-Token": uuid,
                        },
                    }
                )
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        ).count as number | undefined;

    public static readonly countUnread = async (uuid: string, brand: string) =>
        (
            await axios
                .get(
                    environment.api_url + "/" + brand + "/notifications/count",
                    {
                        headers: {
                            "User-Token": uuid,
                        },
                        params: {
                            unread: true,
                        },
                    }
                )
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        ).count as number | undefined;

    public static readonly viewed = async (
        uuid: string,
        brand: string,
        notification: string
    ) =>
        axios.put(
            environment.api_url + "/" + brand + "/notification/" + notification,
            undefined,
            {
                headers: {
                    "User-Token": uuid,
                },
                timeout: 5000,
            }
        );

    public static readonly info = async (
        uuid: string,
        brand: string,
        notificationKey: string
    ) =>
        (await axios
            .get(
                environment.api_url +
                    "/" +
                    brand +
                    "/notification/" +
                    notificationKey,
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as Notification | undefined;
}
